var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.515 2.27a1 1 0 01.97 0l8 4.444c.318.177.515.512.515.875V10a1 1 0 01-.898.995L20 11v6l.102.005A1 1 0 0121 18v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2a1 1 0 01.897-.995L4 17v-6l-.103-.005A1 1 0 013 10V7.59c0-.364.197-.7.515-.876l8-4.444zM4.5 19.5h15v-1h-15v1zM14 11v6h2v-6h-2zm-8.5 6h1v-6h-1v6zM8 17h2v-6H8v6zm3.5 0h1v-6h-1v6zm6 0h1v-6h-1v6zm-13-9.118V9.5h15V7.882L12 3.716 4.5 7.882z",
    fill: "currentColor"
  })));
}
SvgBank.displayName = 'Bank';
export default SvgBank;